import React, { Component } from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import { getUser, getUserToken, isLoggedIn } from "../../reducer";
import { logout } from "../../data/user/actions";
import jwt from "jsonwebtoken";


class PrivateRoute extends Component {

    verifyLogin() {

        if (!this.props.loggedIn) {
            return false;
        }

        return this.checkJWT();

    }

    checkJWT() {

        if (typeof this.props.token === "undefined" || this.props.token === null) {
            this.props.logout();
            return false;
        }
        try {

            const decoded = jwt.decode(this.props.token, { complete: true });
            const dateNow = new Date();
            if (decoded.payload.exp < dateNow.getTime() / 1000) {
                this.props.logout();
                return false;
            }
            return true;

        } catch (err) {
            this.props.logout();
            return false;
        }

    }

    render() {

        const loggedIn = this.verifyLogin();

        const { component: Component, ...rest } = this.props;

        return (
            <Route {...rest} render={props => {
                return (
                    loggedIn
                        ? <Component {...props}>{props.children}</Component>
                        : <Redirect to={{
                            pathname: "/login",
                            state: { from: props.location }
                        }}/>
                );
            }}/>
        );
    }
}

const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state),
    token: getUserToken(state),
    user: getUser(state)
});

const mapDispatchToProps = (dispatch) => {
    return ({
        logout: () => {
            dispatch(logout());
        }
    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js